import React, { useRef } from 'react';
import '../styles/Modal.css';

const Modal = ({ children, showOverflow, onClose, title, contact_title = null, instructions = null, single = false, wider = false, wide = false, header, subheader, footer, overflowy = null, zIndex = null }) => {
    const pointerStartedOnOverlayRef = useRef(false);
    const overlayStyle = zIndex ? { zIndex } : undefined;
    const contentStyle = zIndex ? { zIndex: zIndex + 2 } : undefined;

    const handleOverlayMouseDown = (event) => {
        pointerStartedOnOverlayRef.current = event.target === event.currentTarget;
    };

    const handleOverlayClick = (event) => {
        if (event.target === event.currentTarget && pointerStartedOnOverlayRef.current) {
            onClose?.(event);
        }
        pointerStartedOnOverlayRef.current = false;
    };

    return (
        <div className="modal-overlay" onMouseDown={handleOverlayMouseDown} onClick={handleOverlayClick} style={overlayStyle}>
            <div className={`modal-content${wide ? ' wide' : ''}${wider ? ' wider' : ''}${single ? ' single-view' : ''}${(showOverflow || overflowy) ? ' show-overflow' : ''}`} onClick={(e) => e.stopPropagation()} style={contentStyle}>
                {title && <div className='modal-title'>
                    <div className='title-container'>
                        {contact_title ? (
                            <>
                                <h2 style={{ paddingRight: '15px' }}>{title}</h2>
                                <div className='case-name-item'>
                                    <div className='contact-initials'>
                                        {contact_title.contact_display?.includes('uploads') ? (
                                            <img src={`https://api.casedb.co/${contact_title.contact_display}`} />
                                        ) : (
                                            contact_title.contact_display
                                        )}
                                    </div>
                                    <div>{contact_title.case_name}</div>
                                </div>
                            </>
                        ) : (
                            <>
                                <h2 style={{ paddingRight: '15px' }}>{title}</h2>
                                {instructions && <span className='modal-instructions'>{instructions}</span>}
                            </>
                        )}
                    </div>
                    {header && header}
                </div>}

                {subheader && <div className='modal-subheader'>{subheader}</div>}

                <div className="modal-body" style={{ overflowY: overflowy ? 'visible' : 'auto' }}>
                    {children}
                </div>

                {footer && (
                    <div className="modal-footer">
                        {footer}
                    </div>
                )}

                {!footer && !wide && !header && (
                    <button className="modal-close" onClick={onClose}>×</button>
                )}
            </div>
        </div>
    );
};

export default Modal;